"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("../../../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Legend(props) {
  var legend = props.legend,
      singleAllocation = props.singleAllocation,
      numberFormat = props.numberFormat;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "legend ".concat(singleAllocation ? 'legend-single-item' : '')
  }, legend.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-item",
      key: (0, _index.createUniqueKey)(index, item.label)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-label"
    }, !singleAllocation && /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-point"
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-name"
    }, item.label), /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-value"
    }, numberFormat(item.value)))), !singleAllocation && /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-percent"
    }, item.percent, "%"));
  }));
}

Legend.propTypes = {
  /** Data to be shown on legend */
  legend: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    percent: _propTypes.default.number,
    value: _propTypes.default.number.isRequired
  })),

  /** Single allocation view */
  singleAllocation: _propTypes.default.bool,
  numberFormat: _propTypes.default.func
};
Legend.defaultProps = {
  legend: [],
  singleAllocation: false,
  numberFormat: function numberFormat(num) {
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2
    });
  }
};
var _default = Legend;
exports.default = _default;